<template>
  <div class="c-alert">
    <b-notification
      class="-notification"
      type="is-info is-bold"
      aria-close-label="Close notification"
    >
      📣 Read the latest
      <a
        href="https://www.prnewswire.com/news-releases/crowdflik-announces-launch-of-enterprise-solution-for-patented-mobile-video-collaboration-platform-300924799.html?tc=eml_cleartime"
      >
        news</a
      >
      on our developer solution!
    </b-notification>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.-notification {
  border-radius: 0;
}
</style>
